import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type AccessoriesProps = {
    accessories: Array<Product<ProductFieldSet.ProductTile>>;
    onAdd: (
        sku: string,
        product: Product<ProductFieldSet.ProductTile>
    ) => Promise<void>;
};

const DEFAULT_LIMIT = 3;
const MAX_ITEMS = 9;

const Accessories = ({ accessories, onAdd }: AccessoriesProps) => {
    const { t } = useGranite();
    const [limit, setLimit] = useState(DEFAULT_LIMIT);
    const [isAdding, setIsAdding] = useState(false);

    const onAddAccessory = (product: Product<ProductFieldSet.ProductTile>) => {
        setIsAdding(true);
        onAdd(product.sku, product).finally(() => setIsAdding(false));
    };

    return (
        <>
            <p>{t("general.cartItem.accessory.title")}</p>
            {accessories.slice(0, limit).map((acc) => {
                return (
                    <div
                        className={cn("tw:pb-2")}
                        key={acc.sku}
                    >
                        <Button
                            size="sm"
                            type="button"
                            onClick={() => onAddAccessory(acc)}
                            loading={isAdding}
                            className={cn("tw:inline-block tw:p-1")}
                        >
                            <i className="las la-plus"></i>
                        </Button>
                        <span className={cn("tw:pl-2")}>
                            {acc.title} |{" "}
                            {formatPrice(acc.price?.currentPrice ?? undefined)}
                        </span>
                    </div>
                );
            })}
            {Math.min(accessories.length, MAX_ITEMS) > limit && (
                <Button
                    type="button"
                    color="link"
                    onClick={() => setLimit((state) => state + DEFAULT_LIMIT)}
                >
                    {t("general.cartItem.accessory.showMore")}
                </Button>
            )}
            {limit !== DEFAULT_LIMIT && (
                <Button
                    type="button"
                    color="link"
                    onClick={() => setLimit((state) => state - DEFAULT_LIMIT)}
                >
                    {t("general.cartItem.accessory.showLess")}
                </Button>
            )}
        </>
    );
};

export { Accessories };
